var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div ng-repeat=\"delivery in customer.deliveries\" ng-class=\"{ cancelled: ! delivery.notCancelled() }\">{{ delivery.product }}{{ ((delivery.productCount || 0) <= 1) ? '' : ' (' + delivery.productCount + ')' }}</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/deliveryCountTooltip.jade
 ** module id = 69
 ** module chunks = 1
 **/